
import { MapDrawMenuItem } from "@/types";
import { useMap } from "@/services";
import { computed, defineComponent } from "vue";

export default defineComponent({
  name: "FabMenuItem",
  props: {
    option: {
      type: Object as () => MapDrawMenuItem,
      required: true,
    },
    selected: {
      type: Boolean,
      required: true,
    },
  },
  setup: (props) => ({
    isSelected: computed(
      () => props.selected || useMap().editingMode?.mode === props.option.mode
    ),
  }),
});
